import { Root, RootProps } from "./root";
import { connect } from "react-redux";
import { bootstrap } from "Action_creators/bootstrap";
import { ApplicationStore } from "Store/application";
import { Store } from "Store/index";

type StateProps = Pick<RootProps, "status">;
type DispatchableProps = Pick<RootProps, "initialize">;

function mapApplicationStatus(
  status: ApplicationStore["status"]
): StateProps["status"] {
  switch (status) {
    case "initializing":
      return "INITIALIZING";
    case "loading":
      return "LOADING";
    default:
      return "READY";
  }
}

function mapStateToProps(state: Store): StateProps {
  return {
    status: mapApplicationStatus(state.application.status)
  };
}

function mapDispatchToProps(): DispatchableProps {
  return {
    initialize: () => bootstrap()
  };
}

/** Connected component that renders the Home Page. */
const ROOT_HOC = connect(mapStateToProps, mapDispatchToProps())(Root);
export { ROOT_HOC as RootHOC };
